import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "../../lib/cn.js";

const button = cva(
  "inline-flex items-center justify-center gap-2 rounded-[var(--radius-card)] font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        primary:
          "bg-action-primary text-ink hover:bg-action-primary-strong border border-action-primary-strong/40",
        secondary:
          "bg-action-secondary text-ink border border-line-strong hover:bg-surface-inset",
        danger:
          "bg-action-danger text-ink-inverse hover:bg-action-danger-strong border border-action-danger-strong",
        ghost: "bg-transparent text-ink hover:bg-surface-inset border border-transparent",
      },
      size: {
        sm: "h-9 px-3 text-sm",
        md: "h-11 px-4 text-sm",
        lg: "h-12 px-5 text-base",
      },
    },
    defaultVariants: { variant: "secondary", size: "md" },
  }
);

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof button> {
  asChild?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, variant, size, asChild = false, type = "button", ...props },
  ref
) {
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      ref={ref}
      type={asChild ? undefined : type}
      className={cn(button({ variant, size }), className)}
      {...props}
    />
  );
});
